import React, { Component } from 'react';
import Map from '../../components/Map/Map';
import Modal from '../../components/Modal/Modal';
import RoutePlanner from '../../components/RoutePlanner/RoutePlanner';

class MapContainer extends Component {
    
    state = { 
        showModal: false,
        closeModal: false,
        stop: undefined,
        mapInstance: null,
      };

    openModal = () => { this.setState({ showModal: true }) };
    closeModal = () => { this.setState({ showModal: false }) }

    selectTramStop = (tramStop) => {
        this.setState({ stop: tramStop })
        this.openModal();
    }

    handleMapReady = (map) => {
        this.setState({ mapInstance: map });
    }

    render() {
        return (
            <>
                <Map openNavbar={this.props.openNavbar} selectTramStop={this.selectTramStop} onMapReady={this.handleMapReady} />
                <Modal showModal={this.state.showModal} closeModal={this.closeModal} tramStop={this.state.stop} />
                <RoutePlanner mapInstance={this.state.mapInstance} />
            </>
        );
    }
}
export default MapContainer;
